<div [innerHTML]="linkInfo.longDescription | unescapehtml | sanitize "></div>
<al-link-edit-info-modal></al-link-edit-info-modal>
